var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md user-audio",class:[_vm.isPlayAudio? '' :'none']},[_c('a',{attrs:{"title":_vm.$t('site.func.audio')},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.soundChange($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }